import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export const useWidthSize = () => {
  const $ = _c(6);
  const [widthWindow] = useState(768);
  const [isMobile, setIsMobile] = useState(true);
  let t0;
  let t1;
  if ($[0] !== widthWindow) {
    t0 = () => {
      const handleResize = () => {
        const widthWindowInsideResize = window.innerWidth;
        if (widthWindowInsideResize <= widthWindow) {
          setIsMobile(true);
        } else {
          setIsMobile(false);
        }
      };
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    };
    t1 = [widthWindow];
    $[0] = widthWindow;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== isMobile || $[4] !== widthWindow) {
    t2 = {
      isMobile,
      widthWindow
    };
    $[3] = isMobile;
    $[4] = widthWindow;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};